/* @flow */

import React from 'react';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import MiniDrawer from '../../components/SideMenu/SideMenuDrawer';
import INTEGRATIONS from './constants.integrations';
import styles from './Integrations.module.scss';

export type Props = {
    history: {
        push: Function,
    },
};

const IntegrationsList = ({ history }: Props) => (
    <MiniDrawer redirectTo={history.push}>
        <Box className={styles.container}>
            <Typography variant="h6" className={styles['page-title']}>
                Integrations
            </Typography>
            <Grid container spacing={3} className={styles.gridContainer}>
                {INTEGRATIONS.map(integration => (
                    <Grid item key={integration.id} className={styles['col-md-5ths']}>
                        <Card className={styles['card-container']}>
                            <CardActionArea onClick={() => history.push(integration.path)}>
                                <Box className={styles['overlay-image']}>
                                    <Box
                                        component="img"
                                        src={integration.logo}
                                        alt={integration.name}
                                        className={styles.image}
                                    />
                                    <Box className={styles.hover}>
                                        <Typography className={styles.text}>
                                            {integration.subtitle}
                                        </Typography>
                                    </Box>
                                </Box>
                                <CardContent className={styles['card-action']}>
                                    <Typography className={styles['card-name']}>
                                        {integration.name}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    </MiniDrawer>
);

export default IntegrationsList;

